import { render, staticRenderFns } from "./LeadView.vue?vue&type=template&id=20e71bde&scoped=true"
import script from "./LeadView.vue?vue&type=script&lang=js"
export * from "./LeadView.vue?vue&type=script&lang=js"
import style0 from "./LeadView.vue?vue&type=style&index=0&id=20e71bde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e71bde",
  null
  
)

export default component.exports